import { FetchMonthlyBillsAPIResponse } from '../../../services/monthlyBills'
import { BaseReducerState, MonthlyBillsResponse } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchBillsState = BaseReducerState & {
  data: MonthlyBillsResponse[]
}

export const initialState: FetchBillsState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchAllBills = (
  state: FetchBillsState = initialState,
  action: { type: string; res: any }
): FetchBillsState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_BILLS_BW_DATES}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        // Keep existing data to avoid UI flicker/scroll jump during refresh
        data: state.data,
        error: null,
      }

    case `${ActionTypes.FETCH_BILLS_BW_DATES}_SUCCESS`: {
      const { success, data, message } = <FetchMonthlyBillsAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_BILLS_BW_DATES}_FAILURE`:
      const res = <FetchMonthlyBillsAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_BILLS_BW_DATES}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
